import { getField, updateField } from "vuex-map-fields";

const getDefaultState = () => {
  return {
    accountInqKnd: "", // 계좌조회종류 (2: 대출, 3: 입출금, 4: 예적금)
    accountBox: null,
    RBF0404B40: [], // 예금계좌상세조회
    fatcaBilnTagetDstcd: "", //FATCA징구대상구분코드
    userAcnNtcClosList: [],
    natUserAcnNtcClos: "",
  };
};

const myAccounts = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
    getAccountBox: state => {
      return state.accountBox;
    },
    getWdrwDpostAccountBox: state => {
      let list = [];

      if (state.accountBox) {
        // 예금 (입출금+예적금)
        list = state.accountBox.filter(item => {
          return item.summary.brifAcnoKnd == "1";
        });
      }

      if (list.length > 0) return list[0];
      else return [];
    },
    getLnAccountBox: state => {
      let list = [];

      if (state.accountBox) {
        // 대출
        list = state.accountBox.filter(item => {
          return item.summary.brifAcnoKnd == "2";
        });
      }

      if (list.length > 0) return list[0];
      else return [];
    },
    getWdrwAccountBox: state => {
      let list = [];

      if (state.accountBox) {
        // 입출금
        list = state.accountBox.filter(item => {
          return item.summary.brifAcnoKnd == "3";
        });
      }

      if (list.length > 0) return list[0];
      else return [];
    },
    getDpostAccountBox: state => {
      let list = [];

      if (state.accountBox) {
        // 예적금
        list = state.accountBox.filter(item => {
          return item.summary.brifAcnoKnd == "4";
        });
      }

      if (list.length > 0) return list[0];
      else return [];
    },
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
    setAccountBox: (state, obj) => {
      state.accountBox = obj;
    },
  },
  actions: {
    actSetAccountBox: (context, payload) => {
      context.commit("setAccountBox", payload, context.rootState.loading);
      context.rootState.loading = false;
    },
  },
};

export default myAccounts;
